import type { TFunction } from 'i18next';
import {
  ArrowRightArrowLeft,
  Box,
  FileContract,
  MoneyBillTransfer,
} from '@unified-checkout/design-system/icons/index';
import { TTypeSelectorOptions, TOption } from '@app/dashboard/types/innerLayout/reports';

export const getSelectTypeOptions = (
  t: TFunction
): TTypeSelectorOptions[] => {
  return [
    {
      value: 'transactions',
      label: t('innerLayout.reportsPage.reportTypesFilter.transactions'),
      icon: ArrowRightArrowLeft,
    },
    {
      value: 'orders',
      label: t('innerLayout.reportsPage.reportTypesFilter.orders'),
      icon: Box,
    },
    {
      value: 'invoices',
      label: t('innerLayout.reportsPage.reportTypesFilter.invoices'),
      icon: FileContract,
    },
    {
      value: 'transfers',
      label: t('innerLayout.reportsPage.reportTypesFilter.transfers'),
      icon: MoneyBillTransfer,
    },
  ];
};

export const PAYMENT_METHODS = ["VPC", "UIG", "MIGS", "CYBERSOURCE", "CASH", "PREMIUM", "MPOS", "VF", "AMAN", "CAGG", 
  "VALU", "MPESA", "SUBSCRIPTION", "NIFT", "SPOTII", "JAZZCASH", "CASH_PRESENT", "CASH_DEPOSIT", "MPAY", 
  "GET_GO", "SOUHOOLA", "EASYPAISA", "PREMIUM6V2", "PREMIUM2030", "SHAHRY", "BALANCE_TRANSFER", "BILL_PAYMENT", 
  "FORSA", "SYMPL", "SOUHOOLAV2", "SHAHRY_NEW", "AMAN_V2", "PAYPAL", "TABBY", "HOST", "LUCKY_INSTALLMENT", "PREMIUM6",
  "SOUHOOLAV3", "KHAZNA", "NOWPAY", "VALU_SYMPL", "POSTPAY", "STCPAY", "OMANNET", "HALAN", "CONTACT", "BLNK",
  "TAMARA", "EASYPAISADIRECT", "SYMPL_V2", "DAPI", "KALPAY", "CENOMI", "CRYPTO", "MID_TAKSEET", "SPARK_IT",
  "AMANV3", "INSTAPAY", "SYMPL_QR"];
export const STATUSES = ["Successful", "Pending", "Failed", "Refunded", "Voided"];
export const CHANNELS = ["POS", "Website", "Payment Link", "App", "SDK"];

export const SECONDARY_FILTERS = {
  method: {
    label: 'methodsFilterLabel',
    allLabel: 'allMethods',
    placeholder: 'methodsFilterPlaceholder'
  },
  status: {
    label: 'statusesFilterLabel',
    allLabel: 'allStatuses',
    placeholder: 'statusesFilterPlaceholder'
  },
  channels: {
    
    label: 'channelsFilterLabel',
    allLabel: 'allChannels',
    placeholder: 'channelsFilterPlaceholder'
  },
  devices: {
   
    label: 'devicesFilterLabel',
    allLabel: 'allDevices',
    placeholder: 'devicesFilterPlaceholder'
  }
}
export const getMultiSelectorBtnLabel = (selectedOptions: TOption[], options: TOption[], t: TFunction, allLabel: string) => {
  if (Array.isArray(selectedOptions)) {
    if (selectedOptions.length === options?.length) {
      return allLabel;
    } else if (selectedOptions.length === 0) {
      return t('innerLayout.none');
    } else if (selectedOptions.length === 1) {
      return `${selectedOptions[0].label}`;
    } else {
      return `${selectedOptions[0].label}, +${selectedOptions.length - 1}`;
    }
  } else if (typeof selectedOptions === 'string') {
    return selectedOptions;
  } 
};

export const shouldDisableZatcaMonth = (date: Date): boolean => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const now = new Date();
  
  const isBeforeJune2026 = year < 2026 || (year === 2026 && month < 5);
  const isCurrentOrFutureMonth = year > now.getFullYear() || (year === now.getFullYear() && month >= now.getMonth());

  return isBeforeJune2026 || isCurrentOrFutureMonth;
};